export default {
  // oktan
  '--bob-core-components-color-blue-sky': '#c5e6ef',
  '--bob-core-components-color-white-sky': '#f3fafc',

  // these ways
  '--bob-core-components-color-yellow': '#F9DC5C',
  '--bob-core-components-color-link-light': '#54227C',
  '--bob-core-components-color-link-light-visited': '#8737C7',
  '--bob-core-components-color-link-dark': 'var(--bob-core-components-color-link-yellow)',
  '--bob-core-components-color-link-dark-visited': '#F4A5AF',
  '--bob-core-components-color-light-grey': '#b9b9b9',
  '--bob-core-components-color-light-grey-2': '#e4e4e4',
  '--bob-core-components-color-lighter-grey': '#455b6314',
  '--bob-core-components-color-flow-button-shadow': '#9675d64d',
  '--bob-core-components-color-success': '#088532',
  '--bob-core-components-color-bar-diagram-line-background': '#6211ff4c',
  '--bob-core-components-color-success-background': '#edffd2',
  '--bob-core-components-color-pink-grey-background': '#eee8f2',
  '--bob-core-components-color-mist20': '#f5fafc',
  '--bob-core-components-color-mint-darken': '#72C5DB',

  // BOB homepage / knowit
  '--bob-core-components-color-violet': '#582483',
  '--bob-core-components-color-violet80': '#79509c',
  '--bob-core-components-color-violet60': '#9b7cb5',
  '--bob-core-components-color-violet40': '#bca7cd',
  '--bob-core-components-color-violet20': '#ded3e6',
  '--bob-core-components-color-violet10': '#eee9f3',
  '--bob-core-components-color-violet-darker': '#3e1361',

  '--bob-core-components-color-mint': '#cce8ef',
  '--bob-core-components-color-mint80': '#d6edf2',
  '--bob-core-components-color-mint60': '#e0f1f5',
  '--bob-core-components-color-mint40': '#ebf6f9',
  '--bob-core-components-color-mint20': '#f5fafc',
  '--bob-core-components-color-mint10': '#fafdfd',
  '--bob-core-components-color-mint-darker': '#b1d8e2',

  '--bob-core-components-color-eggplant': '#320e3b',
  '--bob-core-components-color-eggplant80': '#5b3e62',
  '--bob-core-components-color-eggplant60': '#846e89',
  '--bob-core-components-color-eggplant40': '#ad9fb1',
  '--bob-core-components-color-eggplant20': '#d6cfd8',
  '--bob-core-components-color-eggplant10': '#ebe7eb',
  '--bob-core-components-color-eggplant-darker': '#18021d',

  '--bob-core-components-color-iris': '#7b53cc',
  '--bob-core-components-color-iris80': '#9675d6',
  '--bob-core-components-color-iris60': '#b098e0',
  '--bob-core-components-color-iris40': '#cabaeb',
  '--bob-core-components-color-iris20': '#e5ddf5',
  '--bob-core-components-color-iris10': '#f2eefa',
  '--bob-core-components-color-iris-darker': '#6233bd',

  '--bob-core-components-color-grain': '#f9dc5c',
  '--bob-core-components-color-grain80': '#fae37d',
  '--bob-core-components-color-grain60': '#fbea9d',
  '--bob-core-components-color-grain40': '#fdf1be',
  '--bob-core-components-color-grain20': '#fef8de',
  '--bob-core-components-color-grain10': '#fefbef',
  '--bob-core-components-color-grain-darker': '#e8c73d',

  '--bob-core-components-color-grain-shadow-base': 'rgb(193, 171, 76)',
  '--bob-core-components-color-grain-shadow-40':
    "rgba(var('--bob-core-components-color-grain-shadow-base'), 0.4)",

  '--bob-core-components-color-lightblue-shadow-base': 'rgb(169,203,212)',
  '--bob-core-components-color-lightblue-shadow-50': 'rgba(169,203,212,0.5)',

  // Neutrals
  '--bob-core-components-color-coal': '#222222',
  '--bob-core-components-color-sonic': '#767676',
  '--bob-core-components-color-ash': '#949494',
  '--bob-core-components-color-fog': '#dddddd',
  '--bob-core-components-color-platinum': '#f5f5f5',
  '--bob-core-components-color-snow': '#ffffff',

  // functional
  '--bob-core-components-color-rosso': '#d20a0a',
  '--bob-core-components-color-rosso80': '#db3b3b',
  '--bob-core-components-color-rosso60': '#e46c6c',
  '--bob-core-components-color-rosso40': '#ed9d9d',
  '--bob-core-components-color-rosso20': '#f6cece',
  '--bob-core-components-color-rosso10': '#fbe7e7',
  '--bob-core-components-color-rosso-darker': '#af0d0d',
  '--bob-core-components-color-forest': '#53832c',
  '--bob-core-components-color-forest80': '#759c56',
  '--bob-core-components-color-forest60': '#98b580',
  '--bob-core-components-color-forest40': '#b3c8a2',
  '--bob-core-components-color-forest20': '#dde6d5',
  '--bob-core-components-color-forest10': '#eef3ea',
  '--bob-core-components-color-forest-darker': '#2f6404',

  // gradients
  '--bob-core-components-color-dawn': 'linear-gradient(103.68deg, #cce8ef 0%, #7b53cc 100%)',
  '--bob-core-components-color-dusk': 'linear-gradient(103.68deg, #7b53cc 0%, #f9dc5c 100%)',
  '--bob-core-components-color-night': 'linear-gradient(103.68deg, #7b53cc 0%, #320e3b 100%)',
};
